import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { DocumentoElectronicoService } from 'src/app/services/documento-electronico.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { ModalConfirmComponent } from 'src/app/shared/components/modal-confirm/modal-confirm.component';
import { EstadoDocumentoElectronico } from 'src/app/shared/object/IDocumento_electronico.model';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { EmpresasEmitidosDetalleHistoricoComponent } from '../detalle-historico/detalle-historico.component';

@Component({
  selector: 'app-empresas-emitidos-detalle',
  templateUrl: './detalle.component.html',
  styleUrls: ['../empresas-emitidos.component.scss'],
  providers: [SecurityService]
})
export class EmpresasEmitidosDetalleComponent implements OnInit {
  @ViewChild('detalleDocumento', { static: true }) detalleModal: ModalDirective;
  @ViewChild(EmpresasEmitidosDetalleHistoricoComponent, { static: true }) modalDetalleHistorico: EmpresasEmitidosDetalleHistoricoComponent
  @ViewChild(ModalConfirmComponent, { static: true }) modalConfirm: ModalConfirmComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent;
  clienteSeleccionado: any = null;

  // Data & Tmp
  rutEmpresa: number
  sucursalCodigo: number;
  formFiltro: FormGroup;
  loading: boolean = false
  tipo_dte_codigo: number
  estadoDocumento: EstadoDocumentoElectronico
  periodo: Date
  listaDocumentos: Array<any> = null;
  paginationContext: PaginationContext = new PaginationContext()
  currentInputParams: any = null;

  // Utils
  private log: any

  constructor(
    private fb: FormBuilder,
    private accesolocalstorage: SecurityService,
    private messageRendererService: MessageRendererService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private documentoElectronicoService: DocumentoElectronicoService,
    private rutService: RutService,
    private fileDownloadService: FileDownloadService
  ) {
    this.log = this.clog.log('EMPRESAS-EMITIDOS')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo())
    this.configurarForm();
    this.formChangeValue();

    this.paginationContext.RecordsByPage = 10
  }

  configurarForm() {
    this.formFiltro = this.fb.group({
      cliente: [null],
    })
  }

  formChangeValue() {
    this.formFiltro.get('cliente').valueChanges
    .pipe(
      filter(Boolean), 
      debounceTime(500))
    .subscribe((value: string) => {
      console.log('rut cliente change', value)
      this.modalSeleccionarCliente.searchByRut(value);
    })
  }

  loadAndShow(tipo_dte_codigo: number, estadoDocumento: EstadoDocumentoElectronico, periodo: Date) {
    this.tipo_dte_codigo = tipo_dte_codigo
    this.estadoDocumento = estadoDocumento
    this.periodo = periodo
    this.buscar()
    this.detalleModal.show()
  }

  buscar(pageNumber: number = 1) {
    this.listaDocumentos = []
    this.loading = true

    this.paginationContext.CurrentPage = pageNumber

    const inputParams = {
      empresa_rut: this.rutEmpresa,
      tipo_dte_codigo: this.tipo_dte_codigo,
      estadoDocumento: this.estadoDocumento,
      rutCliente: this.clienteSeleccionado ? this.clienteSeleccionado.rut : 0,
      periodo: this.periodo,
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }

    this.currentInputParams = inputParams

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoElectronicoService.obtenerEmitidosDetalle(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaDocumentos = registros
      this.listaDocumentos.forEach((doc, index) => {
        doc.rutFormato = this.rutService.AgregarDV(doc.rut)
        doc.loading = false
        doc.loadingPdf = false
        doc.index = index
      })
      this.loading = false
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show({ paginateLocally: false });
  }
  onClienteSeleccionado({ data }: { data: any }) {
    console.log('cliente encontrado', data)
    this.clienteSeleccionado = data;
    this.clienteSeleccionado.rutFormato = this.rutService.AgregarDV(this.clienteSeleccionado.rut);
    this.formFiltro.get('cliente').setValue(this.clienteSeleccionado.rutFormato, { emitEvent: false });
  }
  onClienteNoEncontrado() {
    console.log('cliente no encontrado')
    this.clienteSeleccionado = null;
    // this.formFiltro.get('cliente').setValue(null, { emitEvent: false });
  }
  limpiarClienteSeleccionado() {
    this.clienteSeleccionado = null;
    this.formFiltro.get('cliente').setValue(null, { emitEvent: false });
    this.modalSeleccionarCliente.cleanLast();
  }

  reSend({ id_lsoft, index }) {
    this.modalConfirm.showWithInlineConfig("Confirmar solicitud", "¿Desea solicitar envío de documento al receptor?", () => {
      const doc = this.listaDocumentos.filter(p => p.index === index)[0]
      doc.loading = true

      this.documentoElectronicoService.EnviarEmitidoAcuseRecibo({
        empresa_rut: this.rutEmpresa,
        id_lsoft,
        type: 1
      },
        ({ mensajes, respuesta }) => {
          doc.loading = false

          const ok = mensajes.filter(m => m.tipo === "ERROR").length === 0
          if (!ok) {
            this.messageRendererService.showErrors(mensajes)
            return
          }

          if (!respuesta) {
            this.toastService.error('No se pudo enviar el email')
            return
          }

          this.toastService.success('Email enviado')
          // this.buscar(this.paginationContext.CurrentPage);
        })
    })
  }

  showHistorico(doc) {
    this.modalDetalleHistorico.loadAndShow(doc)
  }

  downloadExcel() {
    const inputParams = _.cloneDeep(this.currentInputParams)
    delete inputParams.cantidadRegistrosPorPagina
    delete inputParams.paginaActual

    this.log('inputParams', JSON.stringify(inputParams))

    this.documentoElectronicoService.obtenerEmitidosDetalleExcel(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta)
    })
  }

  downloadDocumentoPDF({ id_lsoft }) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      id_lsoft
    }

    const docIndex: number = this.listaDocumentos.findIndex(doc => doc.id_lsoft === id_lsoft)
    const doc: any = this.listaDocumentos[docIndex]
    doc.loadingPdf = true
    this.documentoElectronicoService.urlPdfDocumentoEmitido(inputParams, ({ mensajes, respuesta }) => {
      doc.loadingPdf = false
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes)
        this.messageRendererService.showErrors(mensajes)
        return
      }
      if (respuesta)
        this.fileDownloadService.VerifyAndDownload(respuesta)
    })
  }
}
